import { StorageKey, useStoredValue } from 'app/lib/storage';
import { ThemeModeProvider, ThemeProvider } from 'app/shopify/theme';
import type { Mode } from 'app/shopify/theme/types';
import type { ReactNode } from 'react';
import { canChangeAppTheme } from './app-theme-policy';

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const canChangeTheme = canChangeAppTheme();
  const [storedMode, setStoredMode] = useStoredValue<Mode>(
    StorageKey.ThemeMode,
    'light',
    undefined,
    false,
    canChangeTheme,
  );
  const mode = canChangeTheme && storedMode === 'dark' ? 'dark' : 'light';

  return (
    <ThemeModeProvider mode={mode} onModeChange={canChangeTheme ? setStoredMode : undefined}>
      <ThemeProvider selection={{ breakpoint: 'small', mode }}>{children}</ThemeProvider>
    </ThemeModeProvider>
  );
}
